import { NgModule } from '@angular/core';

import { ApAccordionComponent } from './accordion.component';
import { ApAccordionItemComponent } from './item/item.component';

/**
 * @ngdoc module
 * @name ApAccordionModule
 * @deprecated in favor of [`@asn/accordion`](https://designsystem.acc.aws.devolksbank.net/index.html?path=/docs/web-components-accordion--docs). To be removed with the Angular 23 migration.
 */
@NgModule({
    imports: [ApAccordionComponent, ApAccordionItemComponent],
    exports: [ApAccordionComponent, ApAccordionItemComponent]
})
export class ApAccordionModule {}
